import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import seoRoutes from '../seo/seo-routes.json';

const BASE = 'https://greenlionenergy.de';

/**
 * Globale SEO-Tags auf Router-Ebene: liefert Title, Description, Canonical
 * und OG-Tags für alle öffentlichen Marketing-Routen aus seo-routes.json.
 * Seiten mit eigenem <Helmet> (ownHelmet: true) werden übersprungen, damit
 * keine doppelten Canonical-Links entstehen.
 */
export const GlobalSeo = () => {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const entry = seoRoutes[path];
  if (!entry || entry.ownHelmet) return null;
  const canonical = `${BASE}${entry.canonical || path}`;
  return (
    <Helmet>
      <title>{entry.title}</title>
      <meta name="description" content={entry.description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={entry.title} />
      <meta property="og:description" content={entry.description} />
      <meta property="og:url" content={canonical} />
    </Helmet>
  );
};

export default GlobalSeo;
